import './assets/styles/app.css'

import { BrowserRouter } from 'react-router-dom'
import { SWRConfig } from 'swr'

import Routes from './views'
import swrConfig from './common/swrConfig'

const App = () => {
  return (
    <SWRConfig value={swrConfig}>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </SWRConfig>
  )
}

export default App
